var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"label":_vm.$t('module.meta.keys.chart_default_aggregation'),"items":_vm.aggregationTypes,"item-text":"name","item-value":"value","prepend-icon":"mdi-chart-timeline-variant"},model:{value:(_vm.chartType),callback:function ($$v) {_vm.chartType=$$v},expression:"chartType"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }